import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import IconCreditCard from 'client/icons/CreditCard'
import {
  CreditCardInfoBase,
  ExpiringDate,
  CreditCardWrapper,
  CreditCardNumber,
  Brand,
  Number,
  Holder,
  CreditCardNumberMask,
} from './styles'
import InputLine from 'client/components/InputLine'
import messages from './messages'
import { YEAR_PREFIX, CREDIT_CARD_MASK } from './constants'

const CreditCardInfo = ({ holder, brand, number, expiryDate, inputRadioWrapped }) => {
  const [checked, setCheck] = useState(true)

  function getFormattedDate(date) {
    const month = date.substring(0, 2)
    const year = date.substring(2, 4)
    return `${month}/${YEAR_PREFIX}${year}`
  }

  function getLastFourDigits(creditCardNumber) {
    return creditCardNumber.substring(creditCardNumber.length - 4, creditCardNumber.length)
  }

  const CreditCardResume = () => (
    <CreditCardWrapper>
      <Number>
        <IconCreditCard />
        <Brand>{brand}</Brand>
        <CreditCardNumber>
          <CreditCardNumberMask>{CREDIT_CARD_MASK}</CreditCardNumberMask>
          {getLastFourDigits(number)}
        </CreditCardNumber>
      </Number>

      <Holder>{holder}</Holder>

      <ExpiringDate>
        <FormattedMessage
          {...messages.expiresOn}
          tagName="span"
          values={{ date: getFormattedDate(expiryDate) }}
        />
      </ExpiringDate>
    </CreditCardWrapper>
  )

  return (
    <CreditCardInfoBase withBorder={inputRadioWrapped}>
      {inputRadioWrapped ? (
        <InputLine
          label={<CreditCardResume />}
          id="credit-card-method"
          name="paymentMethod"
          checked={checked}
          type="radio"
          value={`${checked}`}
          onChange={() => setCheck(!checked)}
        />
      ) : (
        <CreditCardResume />
      )}
    </CreditCardInfoBase>
  )
}

CreditCardInfo.propTypes = {
  holder: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  expiryDate: PropTypes.string.isRequired,
  inputRadioWrapped: PropTypes.bool,
}

export default CreditCardInfo
